import frappe from '../frappe';

export async function getInvoiceLines(invoiceId) {
  try {
    const { data } = await frappe.get(
      `/api/resource/Sales%20Invoice%20Item?filters=[["parent","=","${invoiceId}"]]&fields=["item_code","item_name","qty","rate"]&limit=200`
    );
    return data.data.map(line => ({
      product_ref: line.item_code,
      product_label: line.item_name,
      qty: line.qty,
      subprice: line.rate,
    }));
  } catch (error) {
    console.error('Error obteniendo líneas de factura:', error);
    throw error;
  }
}

export async function getOrderLines(orderId) {
  try {
    const { data } = await frappe.get(
      `/api/resource/Sales%20Order%20Item?filters=[["parent","=","${orderId}"]]&fields=["item_code","item_name","qty","rate"]&limit=200`
    );
    return data.data.map(line => ({
      product_ref: line.item_code,
      product_label: line.item_name,
      qty: line.qty,
      subprice: line.rate,
    }));
  } catch (error) {
    console.error('Error obteniendo líneas de orden:', error);
    return [];
  }
}

// Obtiene Sales Orders o Sales Invoices validadas filtradas por bodega
// type: "invoices" | "orders"   whID: nombre del warehouse (ej. "Principal - VE")
export async function getValidatedAndProcessingDocuments(type, whID) {
  try {
    if (type === 'invoices') {
      const { data } = await frappe.get(
        `/api/resource/Sales%20Invoice?filters=[["docstatus","=","1"]]&fields=["name","customer","customer_name","grand_total","posting_date","mode_of_payment","status"]&limit=2000`
      );

      return data.data.map(inv => ({
        ref: inv.name,
        id: inv.name,
        socid: inv.customer,
        status: inv.status,
        name: inv.customer_name,
        carne: null,
        payment_type: inv.mode_of_payment,
        date_creation: inv.posting_date,
        total: inv.grand_total,
        warehouse_id: whID,
        type: 'invoices',
      }));
    }

    // Sales Orders: status "To Deliver and Bill" = validada, pendiente de entrega
    const { data } = await frappe.get(
      `/api/resource/Sales%20Order?filters=[["docstatus","=","1"],["set_warehouse","=","${whID}"],["status","in","To Deliver and Bill,To Bill"]]&fields=["name","customer","customer_name","grand_total","transaction_date","custom_mode_of_payment","status","set_warehouse"]&limit=2000`
    );

    return data.data.map(so => ({
      ref: so.name,
      id: so.name,
      socid: so.customer,
      status: so.status,
      name: so.customer_name,
      carne: null,
      payment_type: so.custom_mode_of_payment,
      date_creation: so.transaction_date,
      total: so.grand_total,
      warehouse_id: so.set_warehouse,
      type: 'orders',
    }));
  } catch (error) {
    console.error(`Error al obtener ${type}:`, error.response?.data || error.message);
    throw error;
  }
}

// Órdenes validadas y en proceso de entrega (status "To Deliver and Bill")
export async function getValidatedAndProcessingOrders(whID) {
  try {
    const { data } = await frappe.get(
      `/api/resource/Sales%20Order?filters=[["docstatus","=","1"],["set_warehouse","=","${whID}"],["status","=","To Deliver and Bill"]]&fields=["name","customer","customer_name","grand_total","transaction_date","custom_mode_of_payment","set_warehouse"]&limit=2000`
    );

    return data.data.map(so => ({
      ref: so.name,
      id: so.name,
      socid: so.customer,
      name: so.customer_name,
      carne: null,
      payment_type: so.custom_mode_of_payment,
      date_creation: so.transaction_date,
      total: so.grand_total,
      warehouse_id: so.set_warehouse,
    }));
  } catch (error) {
    console.error('Error al obtener órdenes:', error.response?.data || error.message);
    throw error;
  }
}

// Órdenes validadas (sin entregar)
export async function getProcessingOrders(whID) {
  try {
    const { data } = await frappe.get(
      `/api/resource/Sales%20Order?filters=[["docstatus","=","1"],["set_warehouse","=","${whID}"],["status","=","To Deliver and Bill"]]&fields=["name","customer","customer_name","grand_total","transaction_date","custom_mode_of_payment","set_warehouse"]&limit=2000`
    );

    return data.data.map(so => ({
      ref: so.name,
      id: so.name,
      payment_type: so.custom_mode_of_payment,
      date_creation: so.transaction_date,
      total: so.grand_total,
      nombre: so.customer_name,
      warehouse_id: so.set_warehouse,
    }));
  } catch (error) {
    console.error('Error al obtener órdenes en proceso:', error.response?.data || error.message);
    throw error;
  }
}
